module.exports = __webpack_public_path__ + "static/bellbanking1.0de2ae28.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellbanking1.jpeg
// module id = 1251
// module chunks = 35783957827783